<template>
  <div
    class="bg-background-neutral-secondary grid grid-cols-3 gap-2 rounded-2xl px-4 py-3"
  >
    <SeatType size="sm" class="truncate" :seat="SEAT_EXAMPLE">
      <p class="text-text-neutral-primary">
        {{ $t('ancillaries.seatMap.legend.free') }}
      </p>
    </SeatType>
    <SeatType size="sm" class="truncate" :seat="BUSY_SEAT_EXAMPLE">
      <p class="text-text-neutral-primary">
        {{ $t('ancillaries.seatMap.legend.busy') }}
      </p>
    </SeatType>
    <SeatType size="sm" class="truncate" :seat="SEAT_EXAMPLE" is-selected>
      <p class="text-text-neutral-primary">
        {{ $t('ancillaries.seatMap.legend.selected') }}
      </p>
    </SeatType>
    <SeatType
      v-for="(seat, i) in seatsExampleForEveryLegend"
      :key="i"
      size="sm"
      class="truncate"
      :seat-colors="getSeatColor(seat)"
      :seat="seat"
    >
      <p v-price="legendTitles[i]"></p>
    </SeatType>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';

  import SeatType from './SeatType.vue';
  import { SEAT_EXAMPLE, BUSY_SEAT_EXAMPLE } from '../config';
  import type { SerializedSeat } from '../lib';
  import type { SeatMapLegend } from '../types';

  const props = defineProps<{
    seatMapLegend: SeatMapLegend;
  }>();

  const legendTitles = computed(() => {
    return Object.keys(props.seatMapLegend);
  });
  const seatsExampleForEveryLegend = computed<SerializedSeat[]>(() => {
    return legendTitles.value.map(title => ({
      ...SEAT_EXAMPLE,
      price: {
        amount: title,
        currency: 'KZT',
      },
    }));
  });

  function getSeatColor(seat: SerializedSeat) {
    const colors =
      props.seatMapLegend && props.seatMapLegend[seat.price?.amount || ''];
    return colors || null;
  }
</script>
